<template>
  <div class="project-listing">
    <vs-card>
      <div slot="header" class="p-3 card-border">
        <div
          class="d-flex align-items-center justify-content-between vx-card__title"
        >
          <h4>{{ $t("labels.projects") }}</h4>
          <div>
            <vs-row v-if="!userId && !vesselId">
              <vs-col vs-w="12">
                <div class="float-right flex">
                  <vs-button
                    v-if="!isUserType('CL')"
                    @click="appPopup()"
                    color="warning"
                    type="filled"
                    class="btn-color"
                    icon-pack="feather"
                    >{{ $t("labels.app_download") }}</vs-button
                  >

                  <vs-button
                    v-if="$store.state.userInfo.type === 'A'"
                    color="dark"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-download"
                    @click="exportData()"
                    class="btn-color ml-4"
                    >{{ $t("labels.export") }}</vs-button
                  >
                </div>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </div>

      <vs-tabs>
        <vs-tab label="In-Progress" class="users">
          <ProjectListByStatus
            status="in-progress"
            :clientId="clientId"
          ></ProjectListByStatus>
        </vs-tab>
        <vs-tab label="Completed" class="users">
          <ProjectListByStatus
            status="completed"
            :clientId="clientId"
          ></ProjectListByStatus>
        </vs-tab>
      </vs-tabs>
    </vs-card>
  </div>
</template>

<script>
import ProjectListByStatus from "@/layouts/components/projects/project-list.vue";
export default {
  props: ["userId", "vesselId", "clientId"],
  data() {
    return {
      appDownload: [
        {
          text: "Windows",
          value:
            "https://gms-staging-files.s3.eu-west-2.amazonaws.com/apps/windows/dev-iqcrm-windows-app.zip",
        },
        {
          text: "Linux",
          value:
            "https://gms-staging-files.s3.eu-west-2.amazonaws.com/apps/linux/iqcrm-linux-app.zip",
        },
      ],
      client_id: null,
      export: 0,
    };
  },
  components: {
    ProjectListByStatus,
  },
  methods: {
    async appPopup() {
      this.popupActiveApp = true;
    },
    async exportData() {
      let input = {
        processing_status: this.filter_processing_status,
        search: this.search,
        status: this.filter_status,
        client_id: this.client_id,
        export: 1,
      };
      // let response = await this.getHTTPPostResponse("/projects", input);
      this.axios
        .post("/projects", input, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let data = response.data;

          this.exportExcelFile(data, "Project");
          this.export = 0;
        })
        .catch((e) => {
          console.log("e", e);
        });
    },
    async downloadApp() {
      this.appDownload.forEach((el) => {
        if (el.text === this.app_value) {
          this.downloadZipApp(el.value, "App");
          this.popupActiveApp = false;
        }
      });
    },
    async downloadReport(index) {
      this.$vs.loading();
      let input = {};
      var formatted_date = new Date().toJSON().slice(0, 10).replace(/-/g, "");
      let pdfName = index.name + "service_reports_" + formatted_date;
      this.axios
        .post("/projects/consultant/report/" + index.id, input, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          let data = response.data;
          console.log("after download ");
          this.downloadZipFile(data, pdfName);
          this.export = 0;
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log("e", e);
        });
    },
  },
};
</script>
<style scoped lang="scss">
p {
  font-weight: 600;
}
.w-10 {
  width: 10% !important;
}
.w-15 {
  width: 15% !important;
}
.w-20 {
  width: 20% !important;
}
.includeIconOnly.large {
  width: 35px !important;
  height: 35px !important;
  /* font-size: .7em; */
}
.wx-100 {
  max-width: 150px;
}
.card-border {
  border-bottom: 3px solid #f6f6f6;
}
</style>
